import Phaser from 'phaser'
import ScanHint from '../components/scan_hint'
import GoalHint from '../components/goal_hint'
import Score from '../components/score'
import ScanningConsole from '../components/scanning_console'
import TouchInput from '../components/touch_input'

export default class HudScene extends Phaser.Scene {
  create ({ game, player }) {
    this.player = player

    this.add.existing(new GoalHint(this))
    this.add.existing(new Score(this, this.player))
    this.add.existing(new ScanningConsole(this))

    if (this.game.device.os.desktop) {
      this.add.existing(new ScanHint(this))
    } else {
      this.touch = new TouchInput(this, this.player)
    }

    this.cameras.main.scrollX = -(this.scale.width - 1280) / 2
    this.scale.on('resize', () => {
      if (this.cameras.main) {
        this.cameras.main.scrollX = -(this.scale.width - 1280) / 2
      }
    })

    this.input.keyboard.createCombo('retrodog')
    this.input.keyboard.once('keycombomatch', () => {
      this.load.once('complete', asset => {
        this.add.image(200, 360, 'retrodog')
      })
      this.load.crossOrigin = 'anonymous'
      this.load.image('retrodog', 'textures/retrodog.png')
      this.load.start()
    })
  }

  update (time, delta) {
    if (this.touch) {
      this.touch.update(time, delta)
    }
  }
}
